import { IHavePath } from "../types/IHavePath";
import { IReleaseVersion } from "../types/IReleaseVersion";
import { IServicePack } from "./IServicePack";

export interface IRelease extends IReleaseVersion {
  SERVICE_PACKS: IServicePack[];
}

export const ReleaseMeta: IHavePath = { path: "/releases" };
